/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RollupTypeFromJSON, RollupTypeToJSON, TagTypeFromJSON, TagTypeToJSON, } from './';
export function CreateTagRequestFromJSON(json) {
    return CreateTagRequestFromJSONTyped(json, false);
}
export function CreateTagRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        type: TagTypeFromJSON(json['type']),
        topDownMapping: !exists(json, 'topDownMapping') ? undefined : json['topDownMapping'],
        topDownEnabled: !exists(json, 'topDownEnabled') ? undefined : json['topDownEnabled'],
        rollupType: !exists(json, 'rollupType') ? undefined : RollupTypeFromJSON(json['rollupType']),
        description: json['description'],
        jsonData: json['jsonData'],
        expression: !exists(json, 'expression') ? undefined : json['expression'],
        ParentId: json['ParentId'],
        connectedTagIds: !exists(json, 'connectedTagIds') ? undefined : json['connectedTagIds'],
        dimensionTagIds: !exists(json, 'dimensionTagIds') ? undefined : json['dimensionTagIds'],
        order: json['order'],
        optimizeCalculation: !exists(json, 'optimizeCalculation') ? undefined : json['optimizeCalculation'],
        readonly: !exists(json, 'readonly') ? undefined : json['readonly'],
        calculateOnDemand: !exists(json, 'calculateOnDemand') ? undefined : json['calculateOnDemand'],
        zConstraint: !exists(json, 'zConstraint') ? undefined : json['zConstraint'],
        fromVersionTagId: !exists(json, 'fromVersionTagId') ? undefined : json['fromVersionTagId'],
        toAccountTagId: !exists(json, 'toAccountTagId') ? undefined : json['toAccountTagId'],
        toVersionTagId: !exists(json, 'toVersionTagId') ? undefined : json['toVersionTagId'],
    };
}
export function CreateTagRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        type: TagTypeToJSON(value.type),
        topDownMapping: value.topDownMapping,
        topDownEnabled: value.topDownEnabled,
        rollupType: RollupTypeToJSON(value.rollupType),
        description: value.description,
        jsonData: value.jsonData,
        expression: value.expression,
        ParentId: value.ParentId,
        connectedTagIds: value.connectedTagIds,
        dimensionTagIds: value.dimensionTagIds,
        order: value.order,
        optimizeCalculation: value.optimizeCalculation,
        readonly: value.readonly,
        calculateOnDemand: value.calculateOnDemand,
        zConstraint: value.zConstraint,
        fromVersionTagId: value.fromVersionTagId,
        toAccountTagId: value.toAccountTagId,
        toVersionTagId: value.toVersionTagId,
    };
}
